require('angular');
require('angular-cookies');
require('angular-inview');
require('angular-ui-router');
require('ng-scrollbar');
require("angular-translate");
require("angular-translate-loader-static-files");
require("angular-touch");


(function () {
angular.module("imagenet", ["ngCookies", 'ngScrollbar', "ui.router", "angular-inview", "pascalprecht.translate",'ngTouch'], function config($httpProvider) {
    $httpProvider.interceptors.push('AuthInterceptor');
})

    .constant("API_URL", "")

    .config(["$locationProvider", function($locationProvider) {
        //$locationProvider.html5Mode(true);
    }])

})();

require('./modules/signedLazyImg');

require("./controllers/loginCtrl");

require("./factories/userFactory");
require("./factories/authInterceptor");
require("./factories/tokenLibrary");